const { client } = require('../../MbaasClient')

export const funcCreateRedundancyPaymentGateway = async (resource, params) => {
  const { data } = await client.getTable('pg_configurations').insert(params.data)
  return { data: data }
}
